import system from 'system-components'
import styled from 'styled-components'

const Image = styled(system({
  is: 'img',
  my: 3,
  borderRadius: 0,
}))`
  box-shadow: 1px 3px 13px -3px rgba(0,0,0,0.3);
`

Image.displayName = 'Image'

export default Image



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Image.js